module.exports = __webpack_public_path__ + "img/15.1e10298b.svg";